// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ModalContext$PorterinFeature from "./ModalContext.mjs";

var provider = ModalContext$PorterinFeature.context.Provider;

function ModalProvider(Props) {
  var value = Props.value;
  var children = Props.children;
  return React.createElement(provider, {
              value: value,
              children: children
            });
}

var make = ModalProvider;

export {
  provider ,
  make ,
}
/* provider Not a pure module */
